import _ from 'lodash';
import { between, packValidateResults, required } from 'helpers/validators';

export const validate = (body: any) => {
  return packValidateResults([
    required(body, ['tempPage']),
    between(body, ['tempPage'], { min: 1, max: body.total_pages }),
  ]);
};
